import { Directive } from '@angular/core';
import { AbstractControl, NG_VALIDATORS, ValidationErrors, Validator } from '@angular/forms';

@Directive({
    selector: '[appEmailValidator]',
    providers: [
        {
            provide: NG_VALIDATORS,
            useExisting: EmailValidatorDirective,
            multi: true
        }
    ],
    standalone: false
})
export class EmailValidatorDirective implements Validator {
  private emailPattern = /^([a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]{1,64})@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/i;

  validate(control: AbstractControl): ValidationErrors | null {
    if(control.value)  {
      const result = this.emailPattern.exec(control.value);
      if (result) {
        const username = result[1];
        if (!username.startsWith('.') && !username.endsWith('.') && username.indexOf('..') === -1) {
          return null;
        }
      }
      return {
        'email': control.value
      };
    }
    else  {
      return null;
    }


  }
}
